import React, { Component } from 'react';
import styled from 'styled-components';

import { PageBaseLayout, ImagePluTextBox, Button, LinkHandle } from '../../..';
import { getData, BreadTreeElement } from '../../../../utils/PageApi';
import { buttonText } from '../../../../constants/buttonText';
import { BottomSectionText } from '../../../../constants/BottomSectionText';
import ProgramBox from './ProgramBox';
import { media } from '../../../../utils/Helper';

const ButtonDiv = styled.div`
  ${media.tablet`text-align: center;`}
  & button {
    ${media.tablet`margin-top: 0;margin-bottom:3.2rem`}
  }
`;

type PageDataType = {
  title: { rendered: string };
  link: string;
  featured_media: number;
  acf: {
    metaDescription: string;
    heroImg: string;
    subtitle: string;
    pageDescription: string;
    pageDescriptionImg: string;
    pageDescriptionText: string;
    pageDescriptionButtonUrl: string;
    pageDescriptionButtonText: string;
    skilledWorkerDescription: string;
    skilledWorkerTarget: string[];
    skilledWorkerApplyCondition: string;
    skilledWorkerEmployerCondition: string;
    skilledWorkerCaution: string;
    internationalGraduateTarget: string[];
    internationalGraduateDescription: string;
    internationalGraduateApplyCondition: string;
    internationalGraduateEmployerCondition: string;
    internationalGraduate: string;
    pilotProgramDescription: string;
    pilotProgramPoints: string;
    CECTarget: string[];
    CECDescription: string;
    CECApplyCondition: string;
    CECCaution: string;
    FSWTarget: string[];
    FSWDescription: string;
    FSWApplyCondition: string;
    FSWCaution: string;
  };
  slug: string;
  parent: number;
};

interface OwnProps {}
interface OwnState {
  data: PageDataType;
  breadTreeElements: BreadTreeElement[];
}

class VisaApply extends Component<OwnProps, OwnState> {
  constructor(ownProps: any, ownState: any) {
    super(ownProps, ownState);
    this.state = {
      data: {
        title: { rendered: '' },
        link: '',
        featured_media: 0,
        acf: {
          metaDescription: '',
          heroImg: '',
          subtitle: '',
          pageDescription: '',
          pageDescriptionImg: '',
          pageDescriptionText: '',
          pageDescriptionButtonUrl: '',
          pageDescriptionButtonText: '',
          skilledWorkerDescription: '',
          skilledWorkerTarget: [],
          skilledWorkerApplyCondition: '',
          skilledWorkerEmployerCondition: '',
          skilledWorkerCaution: '',
          internationalGraduateTarget: [],
          internationalGraduateDescription: '',
          internationalGraduateApplyCondition: '',
          internationalGraduateEmployerCondition: '',
          internationalGraduate: '',
          pilotProgramDescription: '',
          pilotProgramPoints: '',
          CECTarget: [],
          CECDescription: '',
          CECApplyCondition: '',
          CECCaution: '',
          FSWTarget: [],
          FSWDescription: '',
          FSWApplyCondition: '',
          FSWCaution: '',
        },
        slug: '',
        parent: 0,
      },
      breadTreeElements: [],
    };
  }
  createSkilledWorkerData = (data: any) => {
    return {
      description: data.skilledWorkerDescription,
      target: data.skilledWorkerTarget,
      applyCondition: data.skilledWorkerApplyCondition,
      employerCondition: data.skilledWorkerEmployerCondition,
      caution: data.skilledWorkerCaution,
    };
  };
  createInternationalGraduateData = (data: any) => {
    return {
      description: data.internationalGraduateDescription,
      target: data.internationalGraduateTarget,
      applyCondition: data.internationalGraduateApplyCondition,
      employerCondition: data.internationalGraduateEmployerCondition,
      caution: data.internationalGraduateCaution,
      pilotDescription: data.pilotDescription,
      pilotPoints: data.pilotPoints,
    };
  };
  createCECData = (data: any) => {
    return {
      description: data.CECDescription,
      target: data.CECTarget,
      applyCondition: data.CECApplyCondition,
      caution: data.CECCaution,
    };
  };
  createFSWData = (data: any) => {
    return {
      description: data.FSWDescription,
      target: data.FSWTarget,
      applyCondition: data.FSWApplyCondition,
      caution: data.FSWCaution,
    };
  };

  async createData() {
    let pageId = 640;
    const state = await getData<PageDataType>(pageId);
    this.setState(state);
  }

  componentDidMount() {
    this.createData();
  }

  render() {
    let data = this.state.data;
    let dataAcf = data.acf;
    let title = data.title.rendered;

    return (
      <PageBaseLayout
        metaDescription={dataAcf.metaDescription}
        BreadTreeElements={this.state.breadTreeElements}
        heroImgURL={dataAcf.heroImg}
        title={title}
        subTitle={dataAcf.subtitle}
        eyeCatchId={data.featured_media}
        ogLink={data.link}
        bottomSectionText={BottomSectionText.pattern1}
        bottomSectionColor={'#fff'}
        bottomButtonText={buttonText.freeConsulting}
        bottomButtonSize={'23.7rem'}
      >
        <ImagePluTextBox
          imgURL={dataAcf.pageDescriptionImg}
          alt={title}
          isImgRightSide={false}
          classname={null}
        >
          <div
            dangerouslySetInnerHTML={{ __html: dataAcf.pageDescriptionText }}
          />
          <ButtonDiv>
            <Button theme={{ main: '23.7rem' }}>
              <LinkHandle to={dataAcf.pageDescriptionButtonUrl}>
                {dataAcf.pageDescriptionButtonText}
              </LinkHandle>
            </Button>
          </ButtonDiv>
        </ImagePluTextBox>
        <ProgramBox
          skilledWorkerData={this.createSkilledWorkerData(dataAcf)}
          internationalGraduateData={this.createInternationalGraduateData(
            dataAcf,
          )}
          cecData={this.createCECData(dataAcf)}
          fswData={this.createFSWData(dataAcf)}
        />
      </PageBaseLayout>
    );
  }
}
export default VisaApply;
